(function () {
  const SELECTOR =
    'product-info[id^="MainProduct-"] .product__description';

  const MOBILE_QUERY =
    window.matchMedia('(max-width: 749px)');

  let descriptionId = 0;


  function createButton(description) {

    const next = description.nextElementSibling;

    /* 已经创建过 */
    if (next && next.classList.contains('sv-more')) {
      return next;
    }

    const button = document.createElement('button');

    button.type = 'button';
    button.className = 'sv-more';
    button.setAttribute('aria-expanded', 'false');

    /* Accessibility */
    if (!description.id) {
      descriptionId += 1;
      description.id = 'SvDescription-' + descriptionId;
    }

    button.setAttribute(
      'aria-controls',
      description.id
    );

    button.innerHTML =
      '<span class="sv-label">Show more</span>' +
      '<span class="sv-caret" aria-hidden="true"></span>';

    description.after(button);


    button.addEventListener('click', function () {

      const open =
        description.classList.toggle('is-open');

      button.setAttribute(
        'aria-expanded',
        open ? 'true' : 'false'
      );

      const label =
        button.querySelector('.sv-label');

      label.textContent =
        open ? 'Show less' : 'Show more';

    });

    return button;
  }


  function updateDescription(description) {

    /* Desktop */
    if (!MOBILE_QUERY.matches) {

      description.classList.remove(
        'sv-clamp',
        'is-open'
      );

      const oldButton =
        description.nextElementSibling;

      if (
        oldButton &&
        oldButton.classList.contains('sv-more')
      ) {
        oldButton.classList.remove('is-visible');
        oldButton.setAttribute(
          'aria-expanded',
          'false'
        );

        oldButton.querySelector(
          '.sv-label'
        ).textContent = 'Show more';
      }

      return;
    }


    /* Mobile */
    const button =
      createButton(description);

    description.classList.remove('is-open');
    description.classList.add('sv-clamp');

    button.setAttribute(
      'aria-expanded',
      'false'
    );

    button.querySelector(
      '.sv-label'
    ).textContent = 'Show more';


    /*
      等浏览器先完成 3 行折叠，
      再判断 Description 是否真的超出
    */
    requestAnimationFrame(function () {

      const hasOverflow =
        description.scrollHeight >
        description.clientHeight + 2;

      button.classList.toggle(
        'is-visible',
        hasOverflow
      );

      /*
        不到 3 行：
        取消 clamp，也不显示 Show more
      */
      if (!hasOverflow) {
        description.classList.remove(
          'sv-clamp'
        );
      }

    });
  }


  function init(root) {

    const scope = root || document;

    scope
      .querySelectorAll(SELECTOR)
      .forEach(updateDescription);

  }


  /* 正常页面载入 */
  document.addEventListener(
    'DOMContentLoaded',
    function () {
      init(document);
    }
  );


  /* Shopify Theme Editor */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      init(event.target);
    }
  );


  /* Desktop ↔ Mobile 切换 */
  function handleBreakpointChange() {
    init(document);
  }

  if (MOBILE_QUERY.addEventListener) {
    MOBILE_QUERY.addEventListener(
      'change',
      handleBreakpointChange
    );
  } else {
    MOBILE_QUERY.addListener(
      handleBreakpointChange
    );
  }


  /*
    手机横竖屏 / 浏览器宽度变化后重新计算
  */
  let resizeTimer;

  window.addEventListener(
    'resize',
    function () {

      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(
        function () {
          if (MOBILE_QUERY.matches) {
            init(document);
          }
        },
        150
      );

    }
  );


  /*
    Webfont 加载完成后再检查一次，
    避免字体变化导致行数判断偏差
  */
  if (
    document.fonts &&
    document.fonts.ready
  ) {
    document.fonts.ready.then(
      function () {
        init(document);
      }
    );
  }

})();